// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';

// Create a root first (new method for React 18)
const root = ReactDOM.createRoot(document.getElementById('root'));

// Then render your app using that root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);